export const cleanDeviceName = (label) => {
    if (!label || label.trim() === '') {
        return 'Unknown Microphone'
    }

    const cleaningRules = [
        // Remove prefixes
        { pattern: /^Communications - /i, replacement: '' },
        { pattern: /^Default - /i, replacement: '' },

        // Remove Headphones, Speakers, Speaker
        { pattern: /\b(Headphones|Speakers?)\b/i, replacement: '' },

        // Remove brackets and what's inside: (XYZ)
        { pattern: /\((.*?)\)/g, replacement: '$1' },

        // Specific device patterns
        {
            pattern: /Headset \((.*?) Hands-Free.*\)/i,
            replacement: '$1'
        },
        {
            pattern: /Microphone Array \(Intel® Smart Sound Technology.*\)/i,
            replacement: 'Built-in Microphone'
        },
        {
            pattern: /Microphone Array \((.*?)\)/i,
            replacement: 'Built-in Microphone'
        },
        {
            pattern: /\((.*?)\s+Hands-Free.*\)/i,
            replacement: '($1)'
        },

        // Whitespace cleanup
        { pattern: /\s+/g, replacement: ' ' },
        { pattern: /^\s+|\s+$/g, replacement: '' }
    ]

    let cleanedName = label

    cleaningRules.forEach(rule => {
        cleanedName = cleanedName.replace(rule.pattern, rule.replacement)
    })

    cleanedName = cleanedName.trim()

    if (cleanedName.length < 3) {
        cleanedName = 'Microphone'
    }

    return cleanedName
}
